import { useEffect, useState } from "react";

const BREAKPOINTS = {
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	"2xl": 1536,
};

export function useBreakpoint(breakpoint: keyof typeof BREAKPOINTS): boolean {
	const [isBreakPoint, setIsBreakPoint] = useState(false);

	useEffect(() => {
		function checkScreenSize() {
			setIsBreakPoint(window.innerWidth >= BREAKPOINTS[breakpoint]);
		}

		checkScreenSize();
		window.addEventListener("resize", checkScreenSize);

		return () => {
			window.removeEventListener("resize", checkScreenSize);
		};
	}, [breakpoint]);

	return isBreakPoint;
}
